// extracted by mini-css-extract-plugin
module.exports = {"window":"chamba-module--window--1_wW5","container":"chamba-module--container--1NFm2","gridItem":"chamba-module--grid-item--2CE4X","link":"chamba-module--link--3PY_0"};